export default "__VITE_ASSET__QALZM7mU__"